import { render, staticRenderFns } from "./IDCardVerify.vue?vue&type=template&id=0bea913a&scoped=true&"
import script from "./IDCardVerify.vue?vue&type=script&lang=ts&"
export * from "./IDCardVerify.vue?vue&type=script&lang=ts&"
import style0 from "./IDCardVerify.vue?vue&type=style&index=0&id=0bea913a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea913a",
  null
  
)

export default component.exports